var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checked)?_c('v-btn',{staticClass:"white--text",attrs:{"color":_vm.color,"width":"100%","depressed":""},on:{"click":_vm.action}},[_vm._v(_vm._s(_vm.text))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }